import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { UnidataTable } from '~/components';
import { t, number } from '~/helpers';
import { handleExportGeneric } from '~/helpers/exportReports';
import {
  deleteData,
  findData,
  recordFiltering,
} from '~/store/modules/estoqueGeralModulosProdutos/actions';

function EstoqueGeralModulosProdutos() {
  const redux = useSelector((state) => state.estoqueGeralModulosProdutos);

  const header = useMemo(
    () => [
      {
        id: 'codigoposto',
        label: t('s.configuracao.comboio.idposto'),
        filter: { type: 'text' },
      },
      {
        id: 'nomeposto',
        label: t('s.operacao.abastecimento.nomeposto'),
        filter: { type: 'text' },
      },
      {
        id: 'nomeproduto',
        label: t('s.cadastro.empresaveiculo.nomeproduto'),
        filter: { type: 'text' },
      },
      {
        id: 'capacidadetanquefisico',
        label: t('s.configuracao.tanquefisico.capacidadetanquefisico'),
        formatted: (value) => number(value, 0),
      },
      {
        id: 'volumeoperacionaltanquefisico',
        label: t('s.configuracao.tanquefisico.volumeperacionaltanquefisico'),
        formatted: (value) => number(value, 0),
      },
      {
        id: 'volumecontabiltanquefisico',
        label: t('c.menu.stock.estoquecontabil'),
        formatted: (value) => number(value, 0),
      },
      {
        id: 'percentualcontabil',
        label: t('s.geral.opcoes.percentual'),
        formatted: (value) => number(value, 1),
      },
      {
        id: 'volume1tanquefisico',
        label: t('c.menu.stock.estoqueFisico'),
        formatted: (value) => number(value, 0),
      },
      {
        id: 'percentualfisico',
        label: t('s.geral.opcoes.percentual'),
        formatted: (value) => number(value, 1),
      },
    ],
    []
  );

  const fieldlist = [
    'codigoposto',
    'nomeposto',
    'nomeproduto',
    'capacidadetanquefisico',
    'volumeoperacionaltanquefisico',
    'volumecontabiltanquefisico',
    'percentualcontabil',
    'volume1tanquefisico',
    'percentualfisico',
  ];

  const substituirHeader = {
    codigoposto: t('s.configuracao.comboio.idposto'),
    nomeposto: t('s.operacao.abastecimento.nomeposto'),
    nomeproduto: t('s.cadastro.empresaveiculo.nomeproduto'),
    capacidadetanquefisico: t(
      's.configuracao.tanquefisico.capacidadetanquefisico'
    ),
    volumeoperacionaltanquefisico: t(
      's.configuracao.tanquefisico.volumeperacionaltanquefisico'
    ),
    volumecontabiltanquefisico: t('c.menu.stock.estoquecontabil'),
    percentualcontabil: t('s.geral.opcoes.percentual'),
    volume1tanquefisico: t('c.menu.stock.estoqueFisico'),
    percentualcontabil: t('s.geral.opcoes.percentual'),
  };

  return (
    <UnidataTable
      fixed
      redux={redux}
      header={header}
      read={recordFiltering}
      find={findData}
      remove={deleteData}
      keys="codigoposto"
      detach="nomeposto"
      excel
      pdf
      onExport={(formato) =>
        handleExportGeneric({
          endpoint: 'estoquegeralpostosprodutos',
          formato,
          fields: fieldlist,
          headers: substituirHeader,
          redux,
          ordination: redux.params.ordination,
          orderfield: redux.params.orderfield,
          title: 'Relatório de Estoque Geral',
          ignorarFormatacao: {
            capacidadetanquefisico: true,
            volumeoperacionaltanquefisico: true,
            volumecontabiltanquefisico: true,
            percentualcontabil: true,
          },
        })
      }
    />
  );
}

export default EstoqueGeralModulosProdutos;
